export default __webpack_public_path__ + "media/images/mailer-new/heading/favorite-5f62b3688d8d244d8e2bbe7e3bb619cb.png";